export const CardOrderBenefitTypes = [
  'Edenred Duo',
  'Wellbeing',
  'Massage',
  'Transport'
];
